import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Task = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Task' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,20 L24,20 M12,12 L24,12 M12,4 L24,4 M1,19 L4,22 L9,17 M1,11 L4,14 L9,9 M9,1 L4,6 L1,3' />
  </StyledIcon>
);
